<template>
  <div>
    <!-- 查询条件 -->
    <b-row ref="queryFormWrapper" class="p-2">
      <b-col cols="10">
        <b-form inline>
          <!-- <b-form-select
            style="min-width:130px;"
            class="m-1"
            :options="entList"
            v-model="queryParam.criteria.entCode"
             placeholder="请选择企业"
          ></b-form-select> -->
          <!-- <b-form-select
            style="min-width:200px;"
            class="m-1"
            :options="orgList"
            v-model="queryParam.criteria.orgId"
            v-if="showOrg"
            placeholder="请选择机构"
          ></b-form-select> -->
          <b-form-select
            style="min-width:100px;"
            class="m-1"
            :options="taskTypeList"
            v-model="queryParam.criteria.taskTypeId"
          ></b-form-select>
          <b-form-select
            style="min-width:100px;"
            class="m-1"
            :options="statusList"
            v-model="queryParam.criteria.status"
          ></b-form-select>
         
       
     
          <date-picker
              class="ml-2"
              style="width:250px;"
              v-model="queryParam.criteria.daterang"
              :type="daterange.type"
              :format="daterange.format"
              range
              :shortcuts="daterange.ranges"
              placeholder="月度"
            ></date-picker>

          <b-button variant="outline-primary" @click="list(1)" class="m-1">查询</b-button>
          <!-- <json-excel :fields="excel.fields" :fetch="exportData" :name="excel.name" type="xls">
            <b-button variant="primary" class="ml-3">导出</b-button>
          </json-excel>-->
        </b-form>
      </b-col>
      <b-col cols="2" class="mt-3">
     
      </b-col>
    </b-row>
    <!-- 列表 -->
    <div style="min-height:430px;" class="mt-2">
      <b-table
        id="data-table"
        hover
        :fields="fields"
        :items="items.data"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"

      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

      
        <template v-slot:cell(statusMessage)="row">
          <span class="cursor" >
            <div v-if="row.item.status=='0'" :id="row.item.id+'/parse'" :class="getColorClass(row.item.status)" >待处理</div>
            <div v-if="row.item.status=='1'" :id="row.item.id+'/parse'" :class="getColorClass(row.item.status)" >上报中</div>
            <div v-if="row.item.status=='2'" :id="row.item.id+'/parse'" :class="getColorClass(row.item.status)" >已完成</div>
            <div v-if="row.item.status=='3'" :id="row.item.id+'/parse'" :class="getColorClass(row.item.status)" >上报失败</div>

            <b-tooltip
              delay="0"
              :target="row.item.id+'/parse'"
              :id="row.item.id+'/parse/tooltip'"
              :variant="getColorClass(row.item.status)"
              triggers="hover"
              placement="right"
              v-if="row.item.status=='3'"
            >{{row.item.statusMessage}}</b-tooltip>
          </span>
        </template>

      

     

          <template v-slot:cell(actions)="row">
           <b-link @click="openSummaryDialog(row.item)" v-if="(row.item.status=='0'||row.item.status=='3') && row.item.taskTypeId==1" class="mr-2">汇总</b-link> 
          <!-- <b-link
            @click="showManualCheckDialog(row.item)"
            class="mr-2"
            v-if="row.item.invVeriResult!='1'"
          >审核</b-link> -->

          <b-link @click="openUploadFileDialog(row.item)" class="mr-2" v-if="row.item.status!='2' && row.item.taskTypeId==2">上报</b-link>

          <b-link @click="openEditFileDialog(row.item)" class="mr-2"  v-if="row.item.status!='2' && row.item.taskTypeId==2">修改</b-link>

          <b-link @click="handleFinish(row.item)" class="mr-2"  v-if="row.item.status=='1' && row.item.taskTypeId==2">完成</b-link>

          <b-link @click="openEditFileDialog(row.item)" class="mr-2"  v-if="row.item.status=='2' && row.item.taskTypeId==2">查看</b-link>

          <div  class="mr-2"  v-if="(row.item.status=='1')&& row.item.taskTypeId==1">无</div>
          <b-link  class="mr-2"  v-if="(row.item.status=='2')&& row.item.taskTypeId==1" @click="handleViewStat(row.item)">查看</b-link>
        </template>
      </b-table>
    </div>

    <!-- 分页 -->
    <div ref="paginationWrapper" class="mt-3">
      <div class="text-right float-left mx-2" style="height:30px;line-height:30px;"></div>
      <b-pagination
        class="float-right"
        @change="list"
        v-model="queryParam.page"
        :per-page="queryParam.size"
        :total-rows="items.totalElements"
        aria-controls="data-table"
        align="right"
      ></b-pagination>
      <div
        class="text-right float-right mx-2"
        style="height:30px;line-height:30px;"
      >共&nbsp;{{items.totalElements}}&nbsp;条</div>
    </div>

    <loading :show="pageLoading"></loading>

   
    <b-modal
      id="invUploadDialog"
      title="发票数据汇总"
      incline
      v-model="invUploadDialogVisible"
      
      ok-only
    >
      <template slot="modal-ok">确定</template>
       
        <div style="text-align:center;">
          <img :src="qrText"  style="width:200px;"  />

        </div>

        <div>
            
               <p style="margin-bottom:2px;">拥有电子税局身份的用户，通过电子税局app扫描二维码后，系统将自动上报上月发票数据 </p>
                <p> 二维码的有效期为100秒</p>
               
          
          <p>
            登录成功之后，任务会自动开始，并且自动结束
          </p>
        </div>

    </b-modal>
    <b-modal
      id="fileUploadDialog"
      title="文件上报"
      incline
      v-model="fileUploadDialogVisible"
      @ok="handleUploadFile"
    >
      <template slot="modal-ok">上传</template>
      <template slot="modal-cancel">取消</template>

      <validation-observer ref="upFileForm">
        <form>

          <validation-provider
            :rules="validators.rules.date"
            :customMessages="validators.msgs.date"
            name="月份"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              label-align-sm="right"
              :invalid-feedback="validationContext.errors[0]"
            >
              <template slot="label">
                <span class="text-danger"></span>月份:
              </template>
              <date-picker
                :state="validateState(validationContext)"
                style="width:200px;"
                :clearable="false"
                v-model="upFileParam.period"
                type="month"
                format="YYYYMM"
                :disabled = "true"


                value-type="format"
                required
                aria-readonly="true"
              ></date-picker>
            </b-form-group>
          </validation-provider>

          <validation-provider
            :rules="validators.rules.category"
            :customMessages="validators.msgs.category"
            name="类型"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              label-align-sm="right"
              :invalid-feedback="validationContext.errors[0]"
            >
              <template slot="label">
                <span class="text-danger">*</span>类型:
              </template>
              <b-form-select
                style="width:200px;"
                :options="fileTypeList"
                v-model="upFileParam.fileCataCode"
                :state="validateState(validationContext)"
                placeholder="文件类型"
              ></b-form-select>
            </b-form-group>
          </validation-provider>

          

          <validation-provider
            :rules="validators.rules.file"
            :customMessages="validators.msgs.file"
            name="选择文件"
            v-slot="validationContext"
          >
            <b-form-group
              label-cols-sm="2"
              label-align-sm="right"
              :invalid-feedback="validationContext.errors[0]"
            >
              <template slot="label">
                <span class="text-danger">*</span>文件:
              </template>
              <b-form-file
                :multiple="true"
                v-model="upFileParam.file"
                browse-text="选择文件"
                placeholder="请选择一个或多个文件上传"
                :state="validateState(validationContext)"
                required
              ></b-form-file>
            </b-form-group>
          </validation-provider>
        </form>
      </validation-observer>
    </b-modal>


    <b-modal
      id=""
      title="上报文件查看"
      incline
      size="lg"
      v-model="upFileEditDialogVisible"
      ok-only
      
    >
      <template slot="modal-ok">确定</template> 
      <template slot="modal-cancel">关闭</template>
       
        <div>
           月度: {{ upFileDelParam.period }}

        </div>

        <div style="min-height:200px;" class="mt-2">
      <b-table
        id="data-table"
        hover
        :fields="fileFields"
        :items="itemFiles"
        :busy="tableLoading"
        :show-empty="true"
        primary-key="ID"
        empty-text="暂无数据"
        :no-local-sorting="true"

      >
        <template v-slot:table-busy>
          <div class="my-2 d-flex justify-content-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </template>

      

        <template v-slot:cell(fileName)="row">
  
          <b-link @click="handleViewFile(row.item)" class="mr-2" style="text-decoration: underline;" >{{ row.item.fileName }}</b-link>


        </template>

        <template v-slot:cell(actions)="row">
  
          <b-link @click="handleViewFile(row.item)" class="mr-2"  >查看</b-link>

          <b-link @click="handleRemoveFile(row.item)" v-if="upFileDelParam.status!='2'" class="mr-2"  >删除</b-link>

        </template>
      </b-table>
    </div>

    </b-modal>
  </div>
</template>

<script>
import request from "@/plugins/axios";


import * as uploadTaskFacade from "@/api/tcs-upload-task-facade.js";
import * as uploadTaskFileFacade from "@/api/tcs-upload-task-file-facade.js";
// import * as codeListFacade from "@/api/code-list-facade.js";
// import * as orgFacade from "@/api/org-facade.js";
// import * as entFacade from "@/api/ent-facade.js";
import { mapState } from "vuex";
import {
  addDays,
  addHours,
  startOfMonth,
  startOfYear,
  endOfMonth,
  addMonths,
  endOfYear,
  startOfWeek,
  endOfWeek,
  addWeeks
} from "date-fns/esm";

//import dayjs from "dayjs";

export default {
  // validations:
  data() {
    return {
      fileTypeList: [
        { text: "经营场所照片", value: "jycsimg" },
        { text: "营业执照", value: "yyzz" },
        { text: "完税凭证", value: "wspz" },
      
      ],
      // orgList: [
      //   { text: "机构", value: "" },
      //   { text: "机构一", value: "1" }
      // ],
      taskTypeList: [
        { text: "数据上报类型", value: "" },
        { text: "发票数据汇总", value: "1" },
        { text: "文件上报", value: "2" }
      ],
      statusList: [
        { text: "上报进度", value: "" },
        { text: "待处理", value: "0" },
        { text: "上报中", value: "1" },
        { text: "已完成", value: "2" },
        { text: "上报失败", value: "3" }
        
      ],
      entList: [
        { text: "受票方", value: "" },
        { text: "客户一", value: "444444444" },
        { text: "客户二", value: "555555555" }
      ],
      daterange: {
        type: "month",
        format: "YYYYMM",
        ranges: [
          {
            text: "本年",
            onClick: () => [startOfYear(new Date()), endOfYear(new Date())]
          }
        ]
      },
     
      fields: [
        {key:"entName",
         label:"企业名称",
         thStyle:"min-width:200px;",
        },
        {
          key: "period",
          label: "月度",
          thClass: "blank"
        },

        {
          key: "taskTypeName",
          label: "任务类型",
          thClass:"task-name",
        },
        {
          key: "statusMessage",
          label: "上报进度"
        },
        {
          key: "startDateTime",
          label: "上报开始时间",
          thClass:"datetime",
        },
        {
          key: "lastUpdateTime",
          label: "最后更新时间",
          thClass:"datetime",
        },
     
        {
          key: "actions",
          label: "操作",
          thClass: "actions"
        }
      ],

      fileFields: [
        {
          key: "fileCataName",
          label: "类型",
          thClass: "blank"
        },

        {
          key: "fileName",
          label: "文件",
        },
     
        {
          key: "createTime",
          label: "上传时间",
          thClass:"datetime",
        },
       
        {
          key: "actions",
          label: "操作",
          thStyle:"width:120px;"
        }
      ],

      // 以下为数据展示和传输对象，基本上与后台接口的传输对象一致
      items: {
        totalElements: 0,
        data: []
      },
      queryParam: {
        size: 10,
        page: 1,
        criteria: {
          orgId: "",
          entCodes: "",
          taskTypeId: "",
          status:"",
          keyword: "",
          daterang: [],
          dateArr: []
        },
        sortOrder: { creationTime: "descending" }
      },

      itemFiles:[],//元素文件列表
      qrText:null,
      //上传文件param
      upFileParam: {
        taskId: "",
        fileCataCode: "jycsimg",
        file: null,
        period:""
      },

      upFileDelParam: {
        taskId: "",
        id:"",
        period:""
      },
      taskItem:{},
      
      validators: {
        rules: {
          date: {
            required: true
          },
          category: {
            required: true
          },
          file: {
            required: true
          }
        },
        msgs: {
          date: {
            required: "月份不能为空"
          },
          category: {
            required: "类型不能为空"
          },
          file: {
            required: "文件不能为空"
          }
        }
      },
   
     
      // 以下为页面状态控制参数
      showOrg: false,
      pageLoading: false,
      tableLoading: false, // 表格Loading状态
      loginActionFlag:false,

      opIndex: -1, // 当前操作的表格行索引
      // 以上为页面状态控制参数
      invUploadDialogVisible: false,
      fileUploadDialogVisible: false,
      upFileEditDialogVisible:false,
      // 以下为表单校验规则

      // websocket
      sessionId:null,
      websocket: null,
      lockReconnect: false, //是否真正建立连接
      timeout: 30 * 1000, //20秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null //断开 重连倒计时
    };
  },
  
  computed: {
    ...mapState("admin/user", ["info"])
  },
  created() {
    //this.initInfo();
    //获取
    this.queryParam.criteria.entCodes=this.$route.query.e;
  },
  mounted() {
    // 异步加载列表数据
   
    if(this.info.roles.indexOf('tcs_ent')>-1){
      this.fields=this.fields.splice(1);
    }

    //this.handleQuery();
    this.list();

    // 异步加载检索条件中的“纳税人”下拉菜单
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    getColorClass(status) {
      switch (status) {
        case "0":
          return "secondary";
          case "1":
          return "primary";
        case "2":
          return "success";
        case "3":
          return "danger";
      }
    },
    // 异步加载列表数据
    list(page) {
      if (this.queryParam.criteria.daterang) {
        this.queryParam.criteria.dateArr[0] = addHours(
          this.queryParam.criteria.daterang[0],
          8
        );
        this.queryParam.criteria.dateArr[1] = addHours(
          this.queryParam.criteria.daterang[1],
          8
        );
      }
      if (page) {
        this.queryParam.page = page;
      }
      this.tableLoading = true; // 打开表格的Loading状态
      uploadTaskFacade
        .pageList(this.queryParam) // 异步调用后台接口
        .then(res => {
          this.items = res; // 为表格填充数据
          this.tableLoading = false; // 关闭表格的Loading状态
        })
        .catch(err => {
          console.log("err", err);
          this.tableLoading = false;
        });
    },
   

    // 执行查询操作
    handleQuery() {
      this.list();
    },
//打开汇总dialog
openSummaryDialog(item) {
      this.loginActionFlag=true;
      this.taskItem=item;
      this.initWebSocket();
      this.pageLoading=true;
     
    },
    //获取登录二维码
    getLoginCode(item,sessionId){
      let param={
        'taskId':item.id,
        'type':'1',
        'sessionId':sessionId
      }
      uploadTaskFacade.getLoginCode(param).then(()=>{
          
            //this.invUploadDialogVisible=true;  

       }).catch(e=>{
        this.pageLoading=false;
        console.log(e);
       });;
       
    },

    //打开上报上传
    openUploadFileDialog(item){
      Object.assign(this.$data.upFileParam, this.$options.data().upFileParam);

      this.upFileParam.taskId=item.id;
      this.upFileParam.period=item.period;
       this.fileUploadDialogVisible=true;
    },

     //查看文件
     openEditFileDialog(item){
      this.upFileDelParam.taskId=item.id;
      this.upFileDelParam.period=item.period;
      this.upFileDelParam.status=item.status;
      this.pageLoading=true;
       uploadTaskFileFacade.list(item.id).then(res=>{
            this.pageLoading=false;
            this.itemFiles=res;
            this.upFileEditDialogVisible=true;
            

       });
    },
    //查看文件
    listFiles(taskId){
      uploadTaskFileFacade.list(taskId).then(res=>{
          
            this.itemFiles=res;
       });
    },
     //完成动作
    handleFinish(item){
      this.$bvModal
        .msgBoxConfirm("确认完成上报吗？", {
          title: "确认完成上报",
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: "确定",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if (value) {
            uploadTaskFacade
              .update(item.id)
              .then(() => {
                this.pageLoading = false;

                this.$message({
                  message: "完成上报操作成功",
                  type: "success"
                });
                this.list();
              })
              .catch(err => {
                this.pageLoading = false;
                console.log("err", err);
              });
              }
        })
        .catch(err => {
          console.log(err);
        });
    },

    

    //处理上传
    async handleUploadFile(e) {
      e.preventDefault();

      //this.nameState = this.$refs.form.checkValidity();
      var success = await this.$refs.upFileForm.validate();
      if (!success) {
        return;
      }

      this.pageLoading = true;

      await this.uploadFiles();

      this.pageLoading = false;
      //this.upDialogVisible = false;
      this.$message({
        message: "上传操作成功",
        type: "success"
      });
      this.list();
    },

    async uploadFiles() {
      for (var i = 0; i < this.upFileParam.file.length; i++) {
        let uploadParam = new FormData();
        uploadParam.append("file", this.upFileParam.file[i]);
        uploadParam.append("fileCataCode", this.upFileParam.fileCataCode);
        uploadParam.append(
          "taskId",
        this.upFileParam.taskId
        );
        await this.uploadFile(uploadParam);
      }
    },

    async uploadFile(param) {
      try {
        const res = await request({
          url: "eids-invoice/tcs/uploadTaskFile/upload",
          method: "post",
          data: param
        });
        return res;
      } catch (err) {
        this.pageLoading = false;
        throw err;
      }
    },

    //查看文件
    handleViewFile(item) {
        const { href } = this.$router.resolve({
          path: "/tcs/view",
          query: { f: item.fileId }
        });
        
        window.open(href, "_blank");

      
    },

    // 删除上传的文件
    handleRemoveFile(item) {
      this.$bvModal
        .msgBoxConfirm("确认要删除该文件吗？", {
          title: "取消报销",
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: "确定",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if(value){
      this.upFileDelParam.id=item.id;
      uploadTaskFileFacade
        .remove(this.upFileDelParam) // 异步调用后台接口
        .then(() => {
          this.listFiles(this.upFileDelParam.taskId);
          this.$message({
                  message: "删除文件操作成功",
                  type: "success"
                });
          // }
        });
      }
      });
    },

    handleViewStat(item){
      const { href } = this.$router.resolve({
          path: "/tcs/stat",
          query: { e: item.entCode }
        });

        window.open(href, "_blank");
    },
    download(id){
      var downloadUrl = process.env.VUE_APP_INVOICE_DOWNLOAD_PREFIX + id;
      window.open(downloadUrl, "_blank");

    },
    //执行任务
    executeTask(){
      var taskId=this.taskItem.id;
      this.pageLoading=true;
      uploadTaskFacade.executeTask(taskId).then(()=>{
         //执行一遍查询
          this.handleQuery();
           this.pageLoading=false;
      });

    },

    

    //socket相关

    reconnect() {
      //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function () {
        //新连接
        that.initWebSocket();
        that.lockReconnect = false;
      }, 60000);
    },
    reset() {
      //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start() {
      //开启心跳
      var self = this;
      self.timeoutObj && clearTimeout(self.timeoutObj);
      self.serverTimeoutObj && clearTimeout(self.serverTimeoutObj);
      self.timeoutObj = setTimeout(function () {
        //这里发送一个心跳，后端收到后，返回一个心跳消息
        if (self.websock.readyState == 1) {
          //如果连接正常
          let wsCommandDto = {}
          wsCommandDto.sessionId = this.sessionId;
          wsCommandDto.commandId = "heart";
          wsCommandDto.message = "heart"
           
          self.websock.send(JSON.stringify(wsCommandDto));
        } else {
          //否则重连
          self.reconnect();
        }
        self.serverTimeoutObj = setTimeout(function () {
          //超时关闭
          self.websock.close();
        }, self.timeout);
      }, self.timeout);
    },
    //初始化weosocket 
    async initWebSocket() { 
      const wsuri = process.env.VUE_APP_WEBSOCKET_ROOT_PATH + "/eids-invoice/ws/camera";//ws地址
      console.log("正在连接ws: " + wsuri)
      this.websock = new WebSocket(wsuri); 
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage; 
      this.websock.onclose = this.websocketclose;
    }, 

    websocketonopen() {
      console.log("WebSocket连接成功");
      // 成功后，告诉对方我已经连接成功
     
   
      // let wsCommandDto = {}
      // wsCommandDto.sessionId = this.sessionId;
      // wsCommandDto.commandId = "taskLogin";
      // wsCommandDto.message = "登录任务已经连接成功"
      // this.websocketsend(JSON.stringify(wsCommandDto))
    },
    websocketonerror(e) { //错误
      console.log("WebSocket连接发生错误:" + e);
      if(this.loginActionFlag){
      this.reconnect();
      }
    },
    websocketonmessage(e) { //数据接收 
     
      var res=JSON.parse(e.data);
     
      if(res.commandId&&res.commandId=='sendSessionId'){
         this.sessionId=res.sessionId;
         //获取登录二维码
         this.getLoginCode(this.taskItem,this.sessionId);
       
      }else{
      console.log(res);
      var success=res.success;
      var code = res.code;
      if(!success){
        this.$message({
            message: res.msg,
            type: "danger"
         });
         return;
      }
      //显示人脸识别二维码
      if("QRCODE"==code){
        this.pageLoading=false;
        this.invUploadDialogVisible=false;
         this.qrText=res.data; 
         this.invUploadDialogVisible=true;
       
      }
      //登录成功
      if("S000"==code){
         //登录成功处理发票汇总任务
         //this.pageLoading=false;
         this.executeTask();
      }
    }


    }, 

    websocketsend(data) {//数据发送 
      this.websock.send(data); 
    }, 
    websocketclose(e) { //关闭 
        // 向发票审核页面发送退出的命令
        // let wsCommandDto = {}
        // wsCommandDto.sessionId = this.sessionId;
        // wsCommandDto.commandId = "mobileDisconnected";
        // wsCommandDto.message = "已退出"
        // this.websocketsend(JSON.stringify(wsCommandDto))
        if(this.loginActionFlag){
            this.reconnect();
        }
        console.log("connection closed (" + e + ")"); 
    },


   
  }
};
</script>

<style >
.task-name{
  min-width: 150px;
}
.datetime{
  min-width: 180px;
}
.actions {
  width: 150px;
}
.blank {
  width: 80px;
}
.vs__dropdown-toggle {
  height: 33.5px;
}
</style>
